import ConfigContext from './ConfigContext';

export default ConfigContext;
